import { getSingleParams } from '@helpers/getSingleParams'
import { getSearch } from '@helpers/windowLocation'
import type { SignUpState } from '@pages/auth/signUp/shared/types'

const defaultState = { values: {} }

/**
 * @returns SignUpState from localStorage, with querystring overrides
 */
export const getSignUpState = (): SignUpState => ({
  ...defaultState,
  ...(JSON.parse(
    localStorage.getItem('BStock::AP::SignUp') || '{}'
  ) as Partial<SignUpState>),
  ...getSingleParams(getSearch()),
})
